module.exports = __webpack_public_path__ + "static/cubert-logo-91d3e3cbf8e618778c24d0688e2b5939.png";